<div class="lds-ripple" *ngIf="loading$ | async"><div></div><div></div></div>
<div class="w-100 h-100" #container></div>
